import { defineStyleConfig } from '@chakra-ui/react';

export const BadgeStyle = defineStyleConfig({
  defaultProps: {
    colorScheme: 'brand',
    variant: 'solid',
  },
  variants: {
    solid: props => {
      const { colorScheme: c } = props;
      if (c === 'alert') {
        return {
          bg: `${c}.800`,
          color: 'white',
        };
      }
      if (c === 'sustainability-green') {
        return {
          bg: `${c}.900`,
          color: 'white',
        };
      }
      return {
        bg: `${c}.600`,
        color: 'white',
      };
    },
  },
  baseStyle: {
    py: 1,
    px: '14px',
    fontWeight: 'medium',
    borderRadius: 6,
    textTransform: 'inherit',
  },
});
